<div [class]="'product-gallery ' + adClass">
    <div class="row m-0">
        <figure class="product-main-image">
            <span class="product-label label-new" *ngIf="product.new">New</span>
            <span class="product-label label-sale" *ngIf="product.sale_price">Sale</span>
            <span class="product-label label-top" *ngIf="product.top">Top</span>
            <span class="product-label label-out" *ngIf="(!product.stock || product.stock < 1) && showStock && product.variants.length < 1 || (product.variants.length > 1 && allRelatedOutofStock)">Out Of Stock</span>

            <div *ngIf="product.pictures[currentIndex].url.toString().startsWith('https://img.youtube')">
                <iframe width="100%" height="400px" [src]="videoURL" frameborder="0" allowfullscreen></iframe>                    
            </div>

            <div *ngIf="!product.pictures[currentIndex].url.toString().startsWith('https://img.youtube')">
                <molla-image class="d-block position-relative"
                    [src]="product.pictures[currentIndex].url"></molla-image>
                    <a href="javascript:;" class="btn-product-gallery" (click)="openLightBox()">
                        <i class="icon-arrows"></i>
                    </a>
            </div>
            
        </figure>

        <div id="product-zoom-gallery" class="product-image-gallery">
            <a [ngClass]="'product-gallery-item' + ( i === currentIndex ? ' active' : '' )" href="#"
                (click)="changeImage( $event, i, product)" *ngFor="let item of product.sm_pictures; let i = index;">
                <molla-image  [src]="item.url" alt="Product side" class="product-image"></molla-image>                                 
            </a>
        </div>                
    </div>
</div>